"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColors = function getColors(props) {
  return (0, _versions.getColor)(props, 'link');
};

var StyledLink = _styledComponents["default"].a(_templateObject(), function (props) {
  return getColors(props)["default"];
}, function (props) {
  return getColors(props).defaultHover;
});

var Link = function Link(props) {
  return _react["default"].createElement(StyledLink, props, props.children);
};

Link.propTypes = {
  /** URL to follow */
  href: _propTypes["default"].string,

  /** where to open the linked document */
  target: _propTypes["default"].oneOf(['_blank', '_self', '_parent', '_top']),

  /** function to be called on click */
  onClick: _propTypes["default"].func
};
Link.defaultProps = {
  target: '_self'
};
Link.displayName = 'Link';

var _default = (0, _context.withVersion)(Link);

exports["default"] = _default;